// import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import About from './components/About';
import Alert from './components/Alert';
import { useState } from 'react';

// import React from "react";
// import {
//   BrowserRouter as Router,
//   // Switch,
//   Route,
//   Link,
//   Routes
// } from "react-router-dom";


function App() {

  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{
      setAlert(null)
    }, 2000);
  }

  const [mode, setMode] = useState("light"); // Where dark mode in Enabeld or not

  const toggleMode = () => {
    if(mode==="light") {
      setMode("dark");
      document.body.style.backgroundColor = "#19223b";
      document.body.style.color = "white";
      showAlert("Dark mode has been Enabled", "Success");
      document.title = "Dark mode";
    }
    else{
      setMode("light");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
      showAlert("Light mode has been Enabled", "Success");
    }
  }

  return (
    <>

    {/* <Router> */}

    <Navbar title="TeXT~uTAiLS" mode={mode} toggleMode={toggleMode} />

    <Alert alert={alert}/>

    {/* <Routes>
      <Route path="/about" element={<About/>}>  
        </Route> 

      <Route exact path="/" element={}>

      </Route>
    </Routes>

    </Router> */}

    <TextForm showAlert={showAlert} mode= {mode} heading="Enter The Text to Analyse" />


    {/* if want to cahnge mode move it to textform >>> mode={mode} */}

    </>
  );
}
 
export default App;


